<mat-form-field>
  <mat-label *ngIf="titleKey">{{ titleKey | translate }}</mat-label>
  <input matInput [matDatepicker]="picker" [formControl]="date" />
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker [calendarHeaderComponent]="dayMonthHeader"></mat-datepicker>
  <mat-error *ngIf="errorMessageKey">
    {{ errorMessageKey | translate }}
  </mat-error>
</mat-form-field>
